import styles from "./dashboard-header.module.css";
import { useTheme } from "@/components/context/ThemeContext";

export default function DashboardHeader() {
  const { theme } = useTheme();

  return (
    <div className={`${styles.header} ${theme === "dark" ? "dark" : ""}`}>
      <div className={styles.headerContent}>
        <div className={styles.greeting}>
          <h1 className={styles.title}>Welcome Back, Champion</h1>
          <p className={styles.subtitle}>Your Pixel Moon Journey Continues</p>
        </div>
        <div className={styles.headerActions}>
          <button className={styles.notificationBtn}>
            <span className={styles.icon}>🔔</span>
            <span className={styles.badge}>0</span>
          </button>
          <button className={styles.profileBtn}>
            <span className={styles.avatar}>👤</span>
          </button>
        </div>
      </div>
    </div>
  );
}
